import Modal from '@mui/material/Modal';
import makeStyles from '@mui/styles/makeStyles';
import { ANALYTICS_SURFACE } from './analyticsColors';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

const useStyles = makeStyles({
  content: {
    backgroundColor: ANALYTICS_SURFACE,
    padding: '30px',
    width: '80vw',
    minHeight: '90vh',
    height: '90vh',
    maxHeight: '90vh',
    boxSizing: 'border-box',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    zIndex: '9999',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    justifyContent: 'flex-start',
  },
  cameraButton: {
    position: 'absolute',
    top: '5%',
    right: '7%',
    zIndex: '1000',
  },
  closeButton: {
    position: 'absolute',
    top: '12px',
    right: '12px',
    zIndex: '10000',
  },
});
function EnlargedChartModal({ open, onClose, display }) {
  const classes = useStyles();

  return (
    <Modal open={open} onClose={onClose}>
      <div className={classes.content} data-cy="analytics-enlarged-modal">
        <IconButton
          className={classes.closeButton}
          onClick={onClose}
          aria-label="Close enlarged modal"
          data-cy="analytics-enlarged-modal-close"
        >
          <CloseIcon />
        </IconButton>
        {display}
      </div>
    </Modal>
  );
}

export default EnlargedChartModal;
